module.exports = __webpack_public_path__ + "media/images/lb/819-5d6841b8f59219549835acd24e1193a0.svg";